export default [
  {
    path: 'all-exams',
    name: 'all-exams',
    component: () => import('@/views/pages/all-exams/AllExams.vue'),
    meta: {
      pageTitle: 'Exams',
      breadcrumb: [
        {
          text: 'Exams',
          active: true,
        },
      ],
      resource: 'ExamResultInnovation',
    },
  },
]
